import { Models } from 'models/core';
import { PenDimensionDto } from './PenDimension';

export class PenDto {
  Id: number;
  PenIdentifier: string;
  Customer: Models.Customer;
  CustomerId: number;
  PenDimension: PenDimensionDto;
  PenDimensionId: number;
}
